import apiFetch from '../../../utils/apiFetch';

const post = async (url, body, fallback) => {
  const response = await apiFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.message || fallback);
  return result;
};
const base = campaignId => `/campaigns/${encodeURIComponent(campaignId)}/cutting-words`;

/** The DM's attack hit, or its damage is rolled: open a window (or learn nobody can react). */
export const openCuttingWords = (campaignId, request) => post(base(campaignId), request, 'The Cutting Words window could not be opened.');
/** A Bard subtracts, waits for the damage or declines (`helperId`); the DM skips (no `helperId`). */
export const decideCuttingWords = (campaignId, windowId, body) =>
  post(`${base(campaignId)}/${encodeURIComponent(windowId)}/decide`, body, 'Cutting Words could not be saved.');
/** The DM follows one window (`windowId`); a player lists the windows their character may answer (`characterId`). */
export const syncCuttingWords = (campaignId, body) => post(`${base(campaignId)}/sync`, body, 'Cutting Words windows could not be loaded.');
